// Burbuja de bienvenida: 10% en el primer pedido a cambio del correo.
//
// `localStorage` decide si ya se enseñó, no una cookie de sesión: así "la
// primera vez que entra" significa una vez por navegador para siempre, no una
// vez por pestaña. Si el visitante borra datos del sitio, vuelve a verla, que
// es el comportamiento esperado (para el navegador es, otra vez, la primera
// vez).
(() => {
  const VISTA = 'pds_bienvenida';
  const panel = document.querySelector('[data-burbuja]');
  if (!panel) return; // no se pinta ni para clientes identificados ni en /cart ni en /account

  const velo = document.querySelector('[data-burbuja-velo]');
  const form = panel.closest('form');
  const cerrar = panel.querySelector('[data-burbuja-cerrar]');
  const panelOferta = panel.querySelector('[data-burbuja-oferta]');
  const panelExito = panel.querySelector('[data-burbuja-exito-panel]');
  const codigo = panel.dataset.codigo;

  const abrir = () => {
    velo.hidden = false;
    panel.hidden = false;
    document.body.classList.add('bienvenida-abierta');
  };

  const cerrarBurbuja = () => {
    velo.hidden = true;
    panel.hidden = true;
    document.body.classList.remove('bienvenida-abierta');
  };

  const marcarVista = () => {
    try { localStorage.setItem(VISTA, '1'); } catch (e) { /* modo privado: no pasa nada, se verá otra vez */ }
  };

  // Deja el descuento aplicado a esta visita sin que el cliente tenga que
  // teclearlo en el pago. Es una petición GET normal de Shopify, no una API:
  // si por lo que sea fallase (red, adblock), el código escrito en el panel
  // de éxito sigue sirviendo a mano.
  const aplicarDescuento = () => {
    if (!codigo) return;
    fetch(`/discount/${encodeURIComponent(codigo)}`, { credentials: 'same-origin' }).catch(() => {});
  };

  // Si el formulario se envió sin JavaScript, Shopify redirige de vuelta con
  // el panel de éxito ya pintado por Liquid (`data-burbuja-exito`). Aquí solo
  // queda enseñarlo, aplicar el descuento y no volver a molestar.
  if (panel.hasAttribute('data-burbuja-exito')) {
    marcarVista();
    aplicarDescuento();
    abrir();
  } else if (!localStorage.getItem(VISTA)) {
    setTimeout(abrir, 2500);
  }

  cerrar?.addEventListener('click', () => {
    marcarVista();
    cerrarBurbuja();
  });

  velo?.addEventListener('click', () => {
    marcarVista();
    cerrarBurbuja();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !panel.hidden) {
      marcarVista();
      cerrarBurbuja();
    }
  });

  // El envío NO se intercepta con fetch a propósito: el formulario de Shopify
  // lleva un campo de hCaptcha oculto que su propio script rellena de forma
  // asíncrona al enviar. Adelantarse con `fetch` (o con `form.submit()`, que
  // tampoco dispara el evento `submit` de verdad) lee ese campo todavía vacío
  // y Shopify devuelve 400: el correo parecía aceptado pero no se guardaba
  // ningún suscriptor. Se deja el envío nativo, con recarga completa, y
  // `form.posted_successfully?` en Liquid es quien pinta el éxito al volver.
})();
